var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('terminal-modals',{attrs:{"modelName":_vm.model}}),_c('pui-datatable',{attrs:{"modelName":_vm.model,"actions":_vm.actions,"modelColumnDefs":_vm.columnDefs,"showFilterListBtn":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }